export class OrderCreateResponse {
    constructor(response) {
        if (!response) {
            throw new Error("Missing order create response data");
        }
        this.response = response;
    }
    getId() {
        return this.response.id;
    }
    getPayment() {
        return this.response.payment;
    }
    getOrderNumber() {
        return this.response.orderNumber;
    }
}
